// services/commentService.js
import axios from 'axios';

// Base API configuration
const API_URL = process.env.REACT_APP_API_URL || 'https://services.knovik.com';

// Axios instance with base configuration
const api = axios.create({
  baseURL: `${API_URL}/comments`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
const addTokenToRequest = (config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
};

// Error handling
const handleError = (error) => {
  if (error.response) {
    // Server responded with an error
    throw error.response.data;
  } else if (error.request) {
    // Request made but no response
    throw new Error('No response from server');
  } else {
    // Error setting up request
    throw error;
  }
};

// Interceptors
api.interceptors.request.use(addTokenToRequest, (error) => Promise.reject(error));

// Comment Services
export const addComment = async (commentData) => {
  try {
    const response = await api.post('/', commentData);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const fetchComments = async (ideaId) => {
  try {
    const response = await api.get(`/idea/${ideaId}`);
    
    // Ensure we return an array with safe comment structure
    return response.data.map(comment => ({
      ...comment,
      author: comment.author || { name: 'Anonymous' }
    }));
  } catch (error) {
    console.error('Fetch comments error:', error);
    return []; // Return empty array on error
  }
};

export const deleteComment = async (commentId) => {
  try {
    const response = await api.delete(`/${commentId}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateComment = async (commentId, updateData) => {
  try {
    const response = await api.put(`/${commentId}`, updateData);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

const commentService = {
  addComment,
  fetchComments,
  deleteComment,
  updateComment
};

export default commentService;